export default __webpack_public_path__ + "static/media/earth.b676cc54.svg";